import {SearchLinkDefaultBox} from "./search-link.default.box";

export const SearchLinkBox = SearchLinkDefaultBox;